module.exports = __webpack_public_path__ + "img/device.71a9aa08.png";